import { useAsync } from 'react-use';

import { SongTags } from '~/modules/songs/utils/song-tags';

/** One shared empty object: `?? {}` would hand back a new one every render, and anything keyed off
 * it - memos, effect dependencies - would rebuild on every render until the fetch resolved. */
const NONE: SongTags = {};

/**
 * What we know about songs beyond what their files say, fetched the way the note index is. Kept out
 * of the song index because that file is regenerated on every song sync, and this must survive them.
 */
export default function useSongTags() {
  const { value, loading } = useAsync(
    async () => (await fetch('/songs/song-tags.json')).json() as Promise<SongTags>,
    [],
  );

  return { songTags: value ?? NONE, loading };
}
